import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KangaekataPage from "../pages/kangaekata/page";
import DekirukotoPage from "../pages/dekirukoto/page";
// import CasesPage from "../pages/cases/page"; // 元のページ（いつでも戻せます）
import CasesPage from "../pages/cases/coming-soon/page";
import CaseDetailPage from "../pages/cases/detail/page";
import CompanyPage from "../pages/company/page";
import ContactPage from "../pages/contact/page";
import FaqPage from "../pages/faq/page";
import SusumerkataPage from "../pages/susumerkata/page";
import MessagePage from "../pages/message/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kangaekata",
    element: <KangaekataPage />,
  },
  {
    path: "/dekirukoto",
    element: <DekirukotoPage />,
  },
  {
    path: "/cases",
    element: <CasesPage />,
  },
  {
    path: "/cases/:id",
    element: <CaseDetailPage />,
  },
  {
    path: "/company",
    element: <CompanyPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/susumerkata",
    element: <SusumerkataPage />,
  },
  {
    path: "/message",
    element: <MessagePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
